import { render, staticRenderFns } from "./COM_Header_Setting.vue?vue&type=template&id=799e4ba8&"
import script from "./COM_Header_Setting.vue?vue&type=script&lang=js&"
export * from "./COM_Header_Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799e4ba8')) {
      api.createRecord('799e4ba8', component.options)
    } else {
      api.reload('799e4ba8', component.options)
    }
    module.hot.accept("./COM_Header_Setting.vue?vue&type=template&id=799e4ba8&", function () {
      api.rerender('799e4ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/COM_Header_Setting.vue"
export default component.exports